import { Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Constants } from "../../utils/constants";
import { DangerButton, DefaultButton } from "..";

export default function UserRemoveModal({
    open, onClose, onFinish, user
}) {

    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 360,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };



    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-user-remove-title"
            aria-describedby="modal-user-remove-description"
        >
            <Box sx={style}>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    spacing={1}
                >
                    <WarningAmberOutlinedIcon
                        sx={{
                            color: Constants.Colors[currentMode].destructive,
                            fontSize: Constants.Styles.fontSize["2xl"],
                        }}
                    />
                    <Typography
                        sx={{
                            fontWeight: Constants.Styles.fontWeight.semiBold,
                            fontSize: Constants.Styles.fontSize.lg,
                            lineHeight: Constants.Styles.lineHeight.lg,
                        }}
                    >
                        Remove Team Member
                    </Typography>
                </Stack>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.normal,
                        fontSize: Constants.Styles.fontSize.sm,
                        lineHeight: Constants.Styles.lineHeight.sm,
                        color: Constants.Colors[currentMode].mutedForeground,
                        mt: "0.25rem",
                    }}
                >
                    This action cannot be undone.
                </Typography>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.medium,
                        fontSize: Constants.Styles.fontSize.sm,
                        lineHeight: Constants.Styles.lineHeight.sm,
                        marginBlock: "1.0rem",
                    }}
                >
                    Are you sure you want to remove <b>{user?.user_id}</b> from your team?
                </Typography>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.normal,
                        fontSize: Constants.Styles.fontSize.sm,
                        lineHeight: Constants.Styles.lineHeight.sm,
                        color: Constants.Colors[currentMode].mutedForeground,
                    }}
                >
                    They will lose access to all projects and will need to be re-invited to regain access.
                </Typography>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"end"}
                    sx={{
                        mt: "1.5rem",
                    }}
                    spacing={2}
                >
                    <DefaultButton
                        text={"Cancel"}
                        size="medium"
                        onClick={() => {
                            onClose();
                        }}
                        sx={{
                            width: 60,
                        }}
                    />
                    <DangerButton
                        text={"Remove User"}
                        size="medium"
                        onClick={() => {
                            onFinish(user);
                        }}
                        sx={{
                            width: 160,
                        }}
                    />
                </Stack>
            </Box>
        </Modal>
    );
}